import { UserPermission } from './index';

export function isAllowed(expected: UserPermission, actual: UserPermission) {
  if (expected === UserPermission.GUEST) {
    return true;
  }

  return (actual & expected) === expected;
}
